import React from "react";
import PropTypes from "prop-types";
import { Alert, Card } from "react-bootstrap";
import _ from "lodash";


function ErrorBlock({ error }) {
  return (
    <>
      <Card>

        <Card.Header>
          <Card.Title>
            <h6>
              System Error
            </h6>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Alert key="danger" variant="danger">
            {error.status && <>Status: {error.status}<br/></>}
            {error.message && <>Message:{error.message}<br/></>}
            
            {!_.isEmpty(error.errors) ? (
              <div>
                Errors - <br />
                <ul>
                  {error.errors.map(function (err, index) {
                    return (
                      <li key={index}>
                        row num:{index} - {err.message}
                      </li>
                    );
                  })}

                </ul>
              </div>
            ) : null}

          </Alert>
        </Card.Body>
      </Card>
    </>
  );
}

ErrorBlock.propTypes = {
  error: PropTypes.object
};

export default ErrorBlock;
